export const invertedMessages = {
  Decommission: 'CERTS_BULK_DECOMMISSION',
};
